import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledVaccinatedBlueIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 12,
			fill: "#D5F0F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 30L30 22",
			stroke: "#1F3B44",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7071 17.7071L24 28L28 24L17.7071 13.7071C17.3166 13.3166 16.6834 13.3166 16.2929 13.7071L13.7071 16.2929C13.3166 16.6834 13.3166 17.3166 13.7071 17.7071Z",
			fill: "white",
			stroke: "#1F3B44",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5 24.5L22.5 22.5",
			stroke: "#1F3B44",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5 22.5L20.5 20.5",
			stroke: "#1F3B44",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 20.5L18.5 18.5",
			stroke: "#1F3B44",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 14L14 16L16 14L14 12L12 14Z",
			fill: "white",
			stroke: "#1F3B44",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 9L13 13",
			stroke: "#1F3B44",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 30L25 27L27 25L30 28L28 30Z",
			fill: "#4B7987",
			stroke: "#1F3B44",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27 31L31 27",
			stroke: "#1F3B44",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledVaccinatedBlueIcon);
const Memo = memo(ForwardRef);
export default Memo;
